export const getDemographicPickerStyle = () => ({
  demographicPickerContainer: {
    '& > label': {
      marginTop: 24,
    },

    '& .linked-in-target-grid-container': {
      width: '100% !important',

      '& .linked-in-target-grid-view': {
        '& .target-grid-remove-all-container': {
          right: '1px !important',
        },
      },

      '& .company-item-template': {
        display: 'flex',
      },
    },

    '& .linked-in-excluded-grid-container': {
      width: '100% !important',
    },
  },
});
